import RequisitionCard from 'components/cards/RequisitionCard/RequisitionCard'

// Support markdown list breaks with -\s
export const LINE_SPLIT_REGEX = /\r?\n\s?-\s|(\s?\r?\n){2,}|\r?\n/

export const calculateItemHeight = (
	item,
	textsHeights,
	lineHeight,
	cardMargin,
	cards,
	detailLevel,
	screenSize
) => {
	let height = 0
	let textHeight = 0
	if (item.$cardName === 'FinalSituationCard') {
		const numberOfLines =
			item && textsHeights && textsHeights[item.textId]
				? textsHeights[item.textId]
				: 0
		const extraLines =
			numberOfLines > 0
				? numberOfLines + cards.FinalSituationCard.contentDefaultHeight
				: 0
		const extraHeight = extraLines * lineHeight

		if (detailLevel !== 'summary') {
			const cardHeight = cards.FinalSituationCard.defaultHeight

			height = cardHeight + cardMargin + extraHeight
			textHeight = numberOfLines * lineHeight
		} else {
			const cardHeight = cards.FinalSituationCard.defaultSummaryHeight

			height = cardHeight + cardMargin
			textHeight = 0
		}
	} else if (item.$cardName === 'ClinicalEvaluationCard') {
		const numberOfLines =
			item && textsHeights && textsHeights[item.textId]
				? textsHeights[item.textId]
				: 0
		const extraLines =
			numberOfLines > 0
				? numberOfLines +
				  cards.ClinicalEvaluationCard.contentDefaultHeight
				: 0
		const extraHeight = extraLines * lineHeight
		const cardHeight = cards.ClinicalEvaluationCard.defaultHeight

		if (detailLevel !== 'summary') {
			height = cardHeight + cardMargin + extraHeight
			textHeight = numberOfLines * lineHeight
		} else {
			height = cardHeight + cardMargin
			textHeight = 0
		}
	} else if (item.$cardName === 'CommentCard') {
		const numberOfLines =
			item && textsHeights && textsHeights[item.textId]
				? textsHeights[item.textId]
				: 0
		const cardDefaultLines = cards.CommentCard.defaultLines
		const extraLines = Math.max(0, numberOfLines - cardDefaultLines)
		const extraHeight = extraLines * lineHeight

		if (detailLevel !== 'summary') {
			const cardHeight = cards.CommentCard.defaultHeight
			textHeight = numberOfLines * lineHeight
			height = cardHeight + cardMargin + extraHeight
		} else {
			const cardHeight = cards.CommentCard.defaultSummaryHeight
			height = cardHeight + cardMargin
			textHeight = 0
		}
	} else if (item.$cardName === 'RequisitionCard') {
		const cardBaseRows = cards.RequisitionCard.defaultRows

		const suppressRows = 0

		const examsHeight = item.exams
			? 32 +
			  (item.exams.length + suppressRows) *
					cards.RequisitionCard.defaultRowSize
			: 0

		const commentsHeight = item.comments
			? 32 +
			  (item.comments.length + suppressRows) *
					cards.RequisitionCard.defaultRowSize
			: 0
		const numberOfHistoryLines = (item.history?.length || 1) + 1
		let numberOfLines
		numberOfLines =
			item && textsHeights && textsHeights[item.key]
				? textsHeights[item.key]
				: 0

		if (screenSize === 'small') {
			numberOfLines += 1
		}

		const cardDefaultLines = cards.RequisitionCard.defaultLines
		const extraLines = Math.max(0, numberOfLines - cardDefaultLines)
		const extraHeight =
			(extraLines ? extraLines + 2 : extraLines) * lineHeight
		const historyExtraHeight =
			numberOfHistoryLines * cards.RequisitionCard.historyRowSize + 20

		if (detailLevel !== 'summary') {
			const cardBaseHeight = cards.RequisitionCard.defaultHeight
			textHeight = numberOfLines * lineHeight

			height =
				cardBaseHeight +
				examsHeight +
				commentsHeight +
				Math.max(0, (item.medicalActs || []).length - cardBaseRows) *
					cards.RequisitionCard.defaultRowSize +
				cardMargin +
				extraHeight +
				(detailLevel === 'complete' ? historyExtraHeight : 0)
		} else {
			const cardBaseHeight =
				screenSize === 'small' &&
				(item.medicalActs?.length || item.exams?.length)
					? cards.RequisitionCard.defaultSummaryHeight * 2
					: cards.RequisitionCard.defaultSummaryHeight
			height = cardBaseHeight + cardMargin
			textHeight = 0
		}
	} else if (item.$cardName.match(/AppointmentCard$/)) {
		height = cards.AppointmentCard.defaultHeight + cardMargin
		let numberOfLines

		if (item.status?.value === 'executed') {
			numberOfLines =
				item && textsHeights && textsHeights[item.textId]
					? textsHeights[item.textId]
					: 0

			const numberOfHistoryLines = (item.history?.length || 1) + 1
			const cardDefaultLines = cards.AppointmentCard.defaultLines
			const extraLines = Math.max(0, numberOfLines - cardDefaultLines)
			const extraHeight = extraLines * lineHeight
			const historyExtraHeight = numberOfHistoryLines
				? numberOfHistoryLines * cards.AppointmentCard.historyRowSize
				: 0

			if (detailLevel !== 'summary') {
				let requisitionsHeight = 0
				if (item.requisitions?.length) {
					requisitionsHeight = item.requisitions.reduce(
						(acc, elem) => {
							const [height] = calculateItemHeight(
								elem,
								textsHeights,
								lineHeight,
								cardMargin,
								{ RequisitionCard },
								detailLevel
							)

							return (acc += height - 20 || 0)
						},
						0
					)
				}

				const cardHeight = cards.AppointmentCard.executedDefaultHeight
				height =
					cardHeight +
					cardMargin +
					extraHeight +
					(detailLevel === 'complete' ? historyExtraHeight : 0) +
					requisitionsHeight

				textHeight = numberOfLines * lineHeight
			} else {
				const cardHeight =
					screenSize === 'small'
						? cards.AppointmentCard.statusDefaultHeight * 2
						: cards.AppointmentCard.statusDefaultHeight
				height = cardHeight + cardMargin
				textHeight = lineHeight
			}
		}
		if (item.status?.value === 'processing') {
			height = cards.AppointmentCard.defaultHeight + cardMargin
		}
	} else if (item.$cardName === 'EpisodesSeparatorCard') {
		height = cards.EpisodesSeparatorCard.defaultHeight + cardMargin
	} else if (item.$cardName === 'MedicalOpinionCard') {
		const numberOfLines =
			item && textsHeights && textsHeights[item.textId]
				? textsHeights[item.textId]
				: 0
		if (detailLevel !== 'summary') {
			const cardHeight = cards.MedicalOpinionCard.defaultHeight
			const extraHeight =
				cards.MedicalOpinionCard.extraHeight * item.answers.length
			textHeight = numberOfLines * lineHeight
			height = cardHeight + cardMargin + extraHeight + textHeight
		} else {
			const cardHeight = cards.MedicalOpinionCard.summaryDefaultHeight
			height = cardHeight + cardMargin
			textHeight = 0
		}
	} else if (item.$cardName === 'MedicalOpinionTriageCard') {
		let numberOfLines =
			item && textsHeights && textsHeights[item.textId]
				? textsHeights[item.textId]
				: 0

		const bodyPartsHeight = 21 * ((item?.bodyParts ?? []).length + 1)
		if (detailLevel !== 'summary') {
			let cardHeight = 0

			if (!item.missingTriageData.isMissing) {
				cardHeight +=
					cards.MedicalOpinionTriageCard.missingDataLabelSize
			}

			if (screenSize === 'small') {
				cardHeight = item.responseUser
					? cards.MedicalOpinionTriageCard.mobileDefaultHeight
					: cards.MedicalOpinionTriageCard
							.UnanswerdMobileDefaultHeight
			} else {
				cardHeight = item.responseUser
					? cards.MedicalOpinionTriageCard.defaultHeight
					: cards.MedicalOpinionTriageCard.UnanswerdDefaultHeight
			}

			const extraHeight = item.observationTriage
				? cards.MedicalOpinionTriageCard.groupMargin
				: 0

			textHeight = numberOfLines * lineHeight
			height =
				cardHeight +
				cardMargin +
				textHeight +
				extraHeight +
				bodyPartsHeight
		} else {
			const cardHeight =
				cards.MedicalOpinionTriageCard.summaryDefaultHeight
			height = cardHeight + cardMargin
			textHeight = 0
		}
	} else if (item.$cardName === 'CommentThreadCard') {
		const numberOfLines =
			item && textsHeights && textsHeights[item.textId]
				? textsHeights[item.textId]
				: 0
		const cardDefaultLines = cards.CommentThreadCard.defaultLines
		const extraLines = Math.max(0, numberOfLines - cardDefaultLines)
		const extraHeight = extraLines * lineHeight
		const cardHeight = cards.CommentThreadCard.defaultHeight

		height =
			cardHeight + cardMargin + extraHeight - (extraLines > 0 ? 7 : 0)
	} else if (item.$cardName === 'ProcessForwardingCard') {
		height = cards.ProcessForwardingCard.defaultHeight + cardMargin
		textHeight = 0
	} else {
		console.warn('Cannot compute card height', item.$cardName)
	}
	return [height, textHeight]
}
